import { ExperienceType, ShopperExperienceDto } from '@luckycart/xpn-types';
import { SmartOptinsExperience } from '../../common-types/smartOptins.type';
import axios from 'axios';

class SmartOptinsService {
  private hostExperience: string;


  public constructor () {
    this.hostExperience = process.env.REACT_APP_SHOPPER_EXPERIENCE_BASE_URL as string;
  }

  public getExperiences (shopperId: string, siteKey: string, experienceType: string): Promise<ShopperExperienceDto[]> {
    const url = `${this.hostExperience}/v1/experiences?experienceType=${experienceType}&siteKey=${siteKey}&shopperId=${shopperId}`;
    return axios.get(url).then((response) => response.data);
  }

  public async getSmartOptinExperience(
    shopperId: string,
    siteKey: string
  ): Promise<SmartOptinsExperience | null> {
    const experiences = await this.getExperiences(
      shopperId,
      siteKey,
      ExperienceType.SMART_OPTINS
    );

    const filteredExperiences = experiences.filter(
      (experience) => experience.experienceType === ExperienceType.SMART_OPTINS
    ) as SmartOptinsExperience[];

    return filteredExperiences.length > 0 ? filteredExperiences[0] : null;
  }
}


export const smartOptinsServiceInstance = new SmartOptinsService();
